<template>

  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-layout row align-center justify-space-between mb-4>

        <div>
          <slot name="title"/>
        </div>

        <v-btn fab color="accent" @click="$emit('click')" v-on="on">
          <v-icon>add</v-icon>
        </v-btn>

      </v-layout>
    </template>
    <span>Adicionar / Add</span>
  </v-tooltip>

</template>

<script>
/**
 * @group ListHeader
 * Component para adição de lista
 */
export default {
  name: 'AddHeader'
}
</script>
